import { getCoverThumbUrl } from '../../utils/coverUrl';
import React, { useRef } from 'react';
import { User, Camera } from 'lucide-react';

const getCoverUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api')) return `${window.location.origin}${url}`;
  return url;
};

const AuthorBioSection = ({ book, userRole, uploadingPhoto, onAuthorPhotoUpload }) => {
  const inputRef = useRef(null);
  if (!book?.author_bio) return null;

  return (
    <div className="bg-gradient-to-b from-black/65 to-black/55 backdrop-blur-sm py-12" data-testid="author-bio-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="flex items-start gap-6 bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur-sm">
          <div className="flex-shrink-0 relative group">
            {book.author_photo_url ? (
              <img
                src={getCoverThumbUrl(book.author_photo_url)}
                alt={book.author}
                className="w-20 h-20 rounded-full object-cover border-2 border-amber-500/50"
                data-testid="author-photo"
              />
            ) : (
              <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center">
                <User className="h-10 w-10 text-white" />
              </div>
            )}
            {userRole === 'admin' && (
              <>
                <input
                  type="file"
                  ref={inputRef}
                  accept="image/*"
                  onChange={onAuthorPhotoUpload}
                  className="hidden"
                  data-testid="author-photo-input"
                />
                <button
                  onClick={() => inputRef.current?.click()}
                  disabled={uploadingPhoto}
                  className="absolute -bottom-1 -right-1 bg-amber-500 hover:bg-amber-600 text-white rounded-full p-1.5 shadow-lg transition-colors"
                  data-testid="upload-author-photo-btn"
                  title="Upload author photo"
                >
                  <Camera className="h-3.5 w-3.5" />
                </button>
              </>
            )}
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-white mb-1">About the Author</h2>
            <p className="text-amber-400 font-medium mb-4">{book.author}</p>
            <p className="text-gray-300 leading-relaxed whitespace-pre-line">{book.author_bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorBioSection;
